import React, { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import './HatirlatmaSms.css';

// RANDEVU MODÜLÜ — HATIRLATMA SMS (kullanıcı talebi: 2026-09-21).
// VB6 karşılığı: Randevu_VB6\H_SMS_FORM.frm "Hatırlatma SMS 'i".
// Düzen VB6 ile aynı: üstte siyah-sarı başlık şeridi, ortada gönderilmemişler ızgarası
// (satırlar X ile işaretlenir), altta "gönderilmiş olanlar" ızgarası.
//
// VB6'dan BİLEREK FARKLI olanlar:
//   - Ertesi gün resmi/dini tatilse bir sonraki gün listelenir ve durum ekranda yazılır
//     (kullanıcı kuralı: 2026-09-21). VB6'da tatil kontrolü hiç yoktu.
//   - SMS gönderilen randevuya RAND.HATIRLATMA=1 yazılır. VB6'da bu güncelleme yorum satırına
//     alınmıştı: hiçbir kayıt işaretlenmiyor, aynı hastaya tekrar tekrar SMS gidebiliyordu.
//   - Bayrak YALNIZCA gerçekten SMS'i gidene yazılır. VB6'nın (kapalı) güncellemesi o günün
//     TÜM randevularını "gönderildi" sayıyordu — seçilmeyenler sessizce SMS'siz kalıyordu.
//   - "KONUM ilave et" kutusu gerçekten çalışır (VB6'da hiç okunmayan ölü kontroldü).
//   - Telefon normalizasyonu daha toleranslı (0/90 önekleri düzeltilir).

const trTarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');

export default function HatirlatmaSms() {
  const [veri, setVeri] = useState(null);
  const [secililer, setSecililer] = useState([]);
  const [konumEkle, setKonumEkle] = useState(true);      // VB6 SSCheck1 (varsayılan işaretli)
  const [yukleniyor, setYukleniyor] = useState(false);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [ozet, setOzet] = useState(null);
  const [onizleme, setOnizleme] = useState(null);

  const yukle = useCallback(async (konum) => {
    setYukleniyor(true); setHata('');
    try {
      const { data } = await api.get('/hatirlatma-sms/liste', { params: { konumEkle: konum } });
      setVeri(data);
      // VB6 Form_Activate: liste gelince tüm satırlar işaretli gelir.
      setSecililer(data.satirlar.filter(s => !s.engel).map(s => s.id));
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hatırlatma listesi alınamadı.');
      setVeri(null);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => { yukle(konumEkle); }, [yukle, konumEkle]);

  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 8000);
    return () => clearTimeout(z);
  }, [bilgi]);

  const satirlar = useMemo(() => veri?.satirlar || [], [veri]);
  const gonderilmisler = useMemo(() => veri?.gonderilmisler || [], [veri]);
  const secilebilir = useMemo(() => satirlar.filter(s => !s.engel), [satirlar]);

  const tersCevir = (id) => setSecililer(s => (s.includes(id) ? s.filter(x => x !== id) : [...s, id]));
  const hepsiniSec = () => setSecililer(secilebilir.map(s => s.id));
  const hicbiriniSecme = () => setSecililer([]);

  const gonder = async () => {
    if (secililer.length === 0) { setHata('En az 1 adet kayıt işaretlemelisiniz.'); return; }
    if (!window.confirm(`${secililer.length} kişiye topluca SMS yollamak istiyor musunuz?`)) return;

    setGonderiliyor(true); setHata(''); setOzet(null);
    try {
      const { data } = await api.post('/hatirlatma-sms/gonder',
        { randIdler: secililer, tekrarEdilsin: false, konumEkle });
      setOzet({ istenen: secililer.length, ...data });
      setBilgi(`${data.gonderilen} SMS yollandı${data.basarisiz > 0 ? ` · ${data.basarisiz} başarısız` : ''}.`);
      await yukle(konumEkle);
    } catch (err) {
      setHata(err.response?.data?.hata || 'SMS yollanamadı.');
    } finally {
      setGonderiliyor(false);
    }
  };

  return (
    <div className="hsm">
      <div className="hsm-serit">
        <h2 className="hsm-baslik">✉️ Hatırlatma SMS'i <span>· Randevu Modülü</span></h2>
        <div className={`hsm-durum ${hata ? 'hata' : bilgi ? 'bilgi' : ''}`}>
          {hata || bilgi || 'Ertesi günün randevularına hatırlatma mesajı yollanır.'}
        </div>
      </div>

      {/* VB6 Label5: siyah zemin, sarı yazı */}
      <div className="hsm-bant">{veri?.baslik || 'Hatırlatma SMS\'i gönderilmemiş olanlar'}</div>

      {veri?.tatilAtlandi && <div className="hsm-tatil">🎌 {veri.aciklama}</div>}
      {veri?.sablonUyarisi && <div className="hsm-uyari">{veri.sablonUyarisi}</div>}

      <div className="hsm-arac">
        <button type="button" className="hsm-tumu sec" onClick={hepsiniSec}
          disabled={secilebilir.length === 0} title="Tüm kayıtları Seç">( X )</button>
        <button type="button" className="hsm-tumu kaldir" onClick={hicbiriniSecme}
          disabled={secililer.length === 0} title="Tüm Seçimleri Kaldır">(&nbsp;&nbsp;)</button>
        <label className="hsm-konum">
          <input type="checkbox" checked={konumEkle} onChange={e => setKonumEkle(e.target.checked)} />
          <span>SMS'e Varsayılan KONUM'u ilave et</span>
        </label>
        <div className="hsm-sayilar">
          <span><b>{veri?.toplam ?? 0}</b> randevu</span>
          <span className="mavi"><b>{veri?.bekleyen ?? 0}</b> bekliyor</span>
          <span className="yesil"><b>{veri?.gonderilen ?? 0}</b> gönderilmiş</span>
          <span className="secim"><b>{secililer.length}</b> seçili</span>
        </div>
        <button type="button" className="btn btn-secondary" onClick={() => yukle(konumEkle)}
          disabled={yukleniyor || gonderiliyor}>🔄 Yenile</button>
        <button type="button" className="btn btn-primary" onClick={gonder}
          disabled={gonderiliyor || yukleniyor || secililer.length === 0}>
          {gonderiliyor ? 'Yollanıyor...' : `✉️ SMS Yolla (${secililer.length})`}
        </button>
      </div>

      <div className="hsm-not">
        Yalnızca işaretlediğiniz kişilere SMS yollanır; SMS'i gerçekten giden randevu "gönderildi"
        olarak işaretlenir ve bir daha bu listede çıkmaz.
      </div>

      {yukleniyor && <div className="loading">Yükleniyor...</div>}

      {!yukleniyor && veri && (
        <>
          <div className="hsm-liste card">
            <table>
              <thead>
                <tr>
                  <th className="hsm-sec-sutun">Seç</th>
                  <th>Saat</th>
                  <th>Hasta Adı</th>
                  <th>Telefon</th>
                  <th>Doktor</th>
                  <th>Hizmet</th>
                  <th>Durum</th>
                  <th>Mesaj</th>
                </tr>
              </thead>
              <tbody>
                {satirlar.length === 0 && (
                  <tr><td colSpan={8} className="hsm-bos">Listenizde kayıt bulunmamaktadır.</td></tr>
                )}
                {satirlar.map(s => (
                  <tr key={s.id} className={`${s.engel ? 'engelli' : ''} ${secililer.includes(s.id) ? 'secili' : ''}`}
                    onClick={() => !s.engel && tersCevir(s.id)}>
                    <td className="hsm-sec-sutun">{!s.engel && (secililer.includes(s.id) ? 'X' : '')}</td>
                    <td>{s.saat}</td>
                    <td className="hsm-ad">{s.adSoy}</td>
                    <td>{s.telefon || '—'}</td>
                    <td>{s.uzman}</td>
                    <td>{s.hizmet}</td>
                    <td>
                      {s.engel
                        ? <span className="hsm-rozet kirmizi">{s.engel}</span>
                        : <span className="hsm-rozet mavi">Bekliyor</span>}
                    </td>
                    <td>
                      <button type="button" className="hsm-onizle" disabled={!s.mesaj}
                        onClick={e => { e.stopPropagation(); setOnizleme(s); }}>Önizle</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="hsm-bant alt">Hatırlatma SMS'i gönderilmiş olanlar</div>
          <div className="hsm-liste alt card">
            <table>
              <thead>
                <tr><th>Saat</th><th>Hasta Adı</th><th>Telefon</th><th>Doktor</th><th>Hizmet</th></tr>
              </thead>
              <tbody>
                {gonderilmisler.length === 0 && (
                  <tr><td colSpan={5} className="hsm-bos">Bu gün için gönderilmiş hatırlatma yok.</td></tr>
                )}
                {gonderilmisler.map(s => (
                  <tr key={s.id} className="gonderilmis">
                    <td>{s.saat}</td>
                    <td className="hsm-ad">{s.adSoy}</td>
                    <td>{s.telefon || '—'}</td>
                    <td>{s.uzman}</td>
                    <td>{s.hizmet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {ozet && (
        <div className="hsm-modal-zemin" onClick={() => setOzet(null)} role="presentation">
          <div className="hsm-modal" onClick={e => e.stopPropagation()} role="presentation">
            <div className="hsm-modal-bas">
              <strong>Gönderim Özeti</strong>
              <button type="button" onClick={() => setOzet(null)}>✕</button>
            </div>
            <div className="hsm-modal-govde">
              <div className="hsm-ozet">
                <div><span>Gönderilmek istenen toplam SMS</span><b>{ozet.istenen}</b></div>
                <div><span>Başarılı gönderim sayısı</span><b className="yesil">{ozet.gonderilen}</b></div>
                <div><span>Başarısız gönderim sayısı</span><b className="kirmizi">{ozet.basarisiz}</b></div>
              </div>
              {ozet.hatalar?.length > 0 && (
                <ul className="hsm-hatalar">
                  {ozet.hatalar.slice(0, 10).map((h, i) => <li key={i}>{h}</li>)}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

      {onizleme && (
        <div className="hsm-modal-zemin" onClick={() => setOnizleme(null)} role="presentation">
          <div className="hsm-modal" onClick={e => e.stopPropagation()} role="presentation">
            <div className="hsm-modal-bas">
              <strong>Mesaj Önizleme — {onizleme.adSoy}</strong>
              <button type="button" onClick={() => setOnizleme(null)}>✕</button>
            </div>
            <div className="hsm-modal-govde">
              <p className="hsm-modal-tel">{onizleme.telefon || 'Telefon yok'} · {trTarih(veri?.tarih)} {onizleme.saat}</p>
              <div className="hsm-mesaj">{onizleme.mesaj}</div>
              <p className="hsm-modal-not">{onizleme.mesaj.length} karakter</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
